import { render, staticRenderFns } from "./zhihuichengguan.vue?vue&type=template&id=1ada5c44&scoped=true&"
import script from "./zhihuichengguan.vue?vue&type=script&lang=js&"
export * from "./zhihuichengguan.vue?vue&type=script&lang=js&"
import style0 from "./zhihuichengguan.vue?vue&type=style&index=0&id=1ada5c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada5c44",
  null
  
)

export default component.exports